<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
<div class="col-sm-12 px-2 list-container">
      <div v-if="tableData.length > 0" class="col-sm-12 list-content result-table my-2">
          <vue3-datatable
              :rows="tableData"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="75vh"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="emitEdit"
          >
          </vue3-datatable>
      </div>
  </div>
</template>

<script>
import {timeUtils} from '@/components/mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ConversionAccountModelList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        codes: {
            type: Array,
            default() {
                return []
            }
        },
        user: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            tableData: [],
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'code_number', title: this.$t('pricing_model_conversion.code_number'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'code_name', title: this.$t('pricing_model_conversion.code_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract_class', title: this.$t('contracts.contract_class.title'), sort: true, headerClass: 'routa-table-header'},
                {field: 'account_number', title: this.$t('account.account_number'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'account', title: this.$t('account.account'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        results() {
            let temp = []
            this.tableData = []
            this.results.forEach(item => {
                let newItem = {
                    id: item.id,
                    code_number: item.code?.code,
                    code_name: item.code?.name,
                    contract_class: item.contract_class?.name,
                    account: item.account?.name,
                    account_number: item.account?.code
                }
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.tableData = temp
            })
        }
    },
    methods: {
        emitEdit: function (result) {
            let item = this.results.find(item => result.id === item.id)
            if (item) {
                this.$emit('edit', item)
            }
        },
    },
}
</script>
